import { Injectable } from '@angular/core';
import {UserService} from "../services/user.service";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class WalletsService {

    api_url: string = environment.apiEndPoint;

    constructor(private http: HttpClient, private router: Router,private userService : UserService) {}

    /*
         api call for get KYC list
      */
    public getWalletsList(id):Observable<any> {
        return this.userService.userequest('get','customerwallet', null, {userid:id});
    }
    public getWalletscurrency(id):Observable<any> {        
        return this.userService.userequest('get','getwalletcurrency', null, {userid:id.userid,currency:id.currency});
    }
}



// WEBPACK FOOTER //
// ./src/app/services/wallets.service.ts